import type {
  FeatureConfig,
  FeatureConfigValue,
  SiteSpecificFeatureConfigValue,
} from '../types';

export const featureConfigs: (
  | FeatureConfig<SiteSpecificFeatureConfigValue>
  | FeatureConfig<FeatureConfigValue>
)[] = [];
